(function () {

	'use strict';

	/*global $:true */

	let cologicViewService = {

		initView: function () {

			let that = this;
            this.checkInView();

			this.showToTop();
			// this.setBurger();
			this.bindBurger();
			this.bindContactButton();
			this.enableAccordion();
			this.toggleMenue();
			this.slideLoadedSingle();
			this.setMbVideoHeight();
			// this.navigationHandling();
			// this.setYoutubeBox();
            this.checkVideoPlaySetup();
            this.resetAnimationForIos();
			$('.toTopWrapper').click(this.pageToTop);
			$(window).scroll(function () {
                that.runScrollAnimation();
				that.toggleMenue();
				that.checkInView();
				that.showToTop();
			});
            $(window).on('hashchange', function() {
                that.manageScroll();
            });

            $(window).on('resize', function() {
                that.setMbVideoHeight();
                that.equalHeight();
                that.scaleYoutubeBox();
                    $('.mbSliderBox').each(function (){
                        let tempNr = $(this).data('tag-elem-nr');

                        $("#mbSlide-"+tempNr).iosSlider('destroy', true);

                        setTimeout(function () {

                        that.initMBBoxSlider("#mbSlide-"+tempNr, 1, tempNr);
                        }, 100);
                    });

            });


			this.equalHeight();
			this.initSlideFunc();
			this.sizeSliderImages();
            this.setYoutubeBox();
            this.mixedEvents();
            this.manageScroll();
            this.setProboBoxClick();
            this.checkDownloadSum();
		},

		//--------------------------------------


        resetAnimationForIos: function (){
		    // if(this.isiOS()){
		        $('.teaser-content').removeClass('animated animated-up')
            // }
        },

        isiOS: function () {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        },



		scrollToY: function (_y) {
			$('html, body').animate({scrollTop: _y}, '200');
		},

		goToId: function (_id) {
			let offSet = $('#headerMain').innerHeight();
			this.scrollToY($('#' + _id).offset().top - (offSet + 50));
		},

		scrollToId: function (_id) {
			let offSet = $('#headerMain').innerHeight();
			this.scrollToY($('#' + _id).offset().top - (offSet + 50));
		},

		mixedEvents: function () {
            let offSet = $('#headerMain').innerHeight();
            let that = this;
            $('.sbDetailLink').on('click',function (){
                that.scrollToY($(this).parent().parent().find('.serienBoxDetails').offset().top - (offSet + 50));
            });
		},

		equalHeight: function () {
            if($(window).width() > 990) {

                let addedClasses = "";
                let addedClassesCol = "";
                if (arguments[0] !== undefined) addedClasses = arguments[0];
                if (arguments[1] !== undefined) addedClassesCol = arguments[1];
                $('.sameHeightRow .mubo-b-1').css("height", "auto");
                // setTimeout(function () {
                $('.sameHeightRow' + addedClasses).each(function () {
                    let highestBox = 0;
                    $('.mubo-b-1' + addedClassesCol, this).each(function () {

                        if ($(this).height() > highestBox) {
                            highestBox = $(this).height();
                        }
                    });
                    $('.mubo-b-1' + addedClassesCol, this).height(highestBox);
                });
                $('.sameHeightRowInk' + addedClasses).each(function () {
                    let highestBox = 0;
                    highestBox = $('.row', this).height();
                    $('.mubo-b-1' + addedClassesCol, this).height(highestBox);
                });

                $('.archOuter .archInner').css("height", "auto");
                $('.archOuter').each(function () {
                    let highestBox = 0;
                    $('.archInner', this).each(function () {
                        if ($(this).height() > highestBox) {
                            highestBox = $(this).height();
                        }
                    });
                    highestBox += 40;
                    $('.archLeft', this).height(highestBox);
                });

                //Referenz-Seite
                $('.referenz-outer .referenz').css("height", "auto");
                $('.referenz-outer').each(function () {
                    let highestBox = 0;
                    $('.referenz', this).each(function () {
                        if ($(this).height() > highestBox) {
                            highestBox = $(this).height();
                        }
                    });
                    $('.referenz', this).height(highestBox);
                });
                //teaser-product-s
                let top = 0;
                let counter = 0;
                let runHight = 0;
                $('.refImageBox').each(function ( ) {
                    let top2 = $(this).position().top;
                    if(top != 0){
                        if(top2 != top){
                            if(runHight > 0){
                                // console.log('equalHeight for' + counter);
                                let highestBox = 0;
                                $('.refBoxImageHeightSizeer'+counter).each(function () {
                                    $(this).css("height", "auto");
                                    if ($(this).height() > highestBox) {
                                        highestBox = $(this).height();
                                    }
                                });
                                $('.refBoxImageHeightSizeer'+counter).height(highestBox);

                            }
                            counter++
                            runHight = 0;
                        }else{
                            runHight++
                        }
                    }
                    $(this).addClass('refBoxImageHeightSizeer'+counter);

                    top = top2;

                });
                //teaser-product-s
                $('.crawlOuter.teaser-product-s').each(function () {
                    let highestBox = 0;
                    $('.teaser-product-s', this).each(function () {
                        $(this).css("height", "auto");
                        if ($(this).height() > highestBox) {
                            highestBox = $(this).height();
                        }
                    });
                    $('.teaser-product-s', this).height(highestBox);
                });

                let highestHeaderBox = 0;

                $('.headWrapper .headerPart').each(function () {
                    if ($(this).height() > highestHeaderBox) {
                        highestHeaderBox = $(this).height();
                    }
                });
                $('.headWrapper .headerPart').height(highestHeaderBox);
            }

		},

		equalHeightAccord: function () {

            let addedClasses = "";
			let addedClassesCol = "";
			if (arguments[0] !== undefined) addedClasses = arguments[0];
			if (arguments[1] !== undefined) addedClassesCol = arguments[1];
			$('.sameHeightRow .mubo-b-1').css("height", "auto");
				$('.sameHeightRow' + addedClasses).each(function () {
					let highestBox = 0;
					$('.mubo-b-1' + addedClassesCol, this).each(function () {
                        if ($(this).height() > highestBox) {
							highestBox = $(this).height();
						}
					});
					$('.mubo-b-1' + addedClassesCol, this).height(highestBox);
				});

		},

        manageScroll: function(){
            // let mainMenu =  $('#headerMain');
            let tempHash = window.location.hash;
           if(tempHash!=undefined&&tempHash!=''&&tempHash!=null&&tempHash!=0){
                if($(tempHash).length > 0){
                    $('#headerMain').removeClass('open');
                    // this.toggleMenu(mainMenu)
                    let offSet = $('#headerMain').innerHeight();
                    let tempPosition = $(tempHash).offset().top;
                    let newPosition = tempPosition - offSet;
                    // $(tempHash).click();
                    console.log(tempHash);
                    console.log(tempPosition);
                    console.log(newPosition);

                    $('html, body').animate({
                        scrollTop:newPosition
                    },500);
                    // },'slow');
                }

            }

        },

        getURLPath: function(param){
		    let paramVal = false;
		    try {
                if($.QueryString[param]){
                    paramVal = $.QueryString[param];
                }
            }catch (e) {

            }
            return paramVal;
        },


        setMbVideoHeight: function(){
		    $('.v-std').each(function(){
		       $(this).css('height',(($(this).width() / 16) * 9));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.v-qua').each(function(){
		       $(this).css('height', $(this).width() );
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.v-high').each(function(){
                $(this).css('height',(($(this).width() / 9) * 16));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });
		    $('.boxVideo').each(function(){
		       $(this).css('height',(($('.mb-background-video', this).width() / 16) * 8.75));
		       // $(this).css('height',(($('.mb-background-video', this).width() / 16) * 7));
            });

            $('.teaser-image .std-video-inner').each(function(){
                $(this).css('height', $(this).width() );
            });

        },


        showToTop: function () {
                let slimit = 100;
                let bScroll = Number($("body").scrollTop());
                let hScroll = Number($("html").scrollTop());
                if (hScroll < slimit && bScroll < slimit)
                    $(".toTopWrapper.showDialog").removeClass('showDialog');
                if (hScroll > slimit || bScroll > slimit)
                    $(".toTopWrapper").addClass('showDialog');
        },

        pageToTop() {
            $("html,body").animate({scrollTop: 0}, '500');
        },

		//---------------------------------------------------------
        checkVideoPlaySetup: function(){
            let that = this;
            // $('.startVideoInView').each(function(){
            //    $('.mb-background-video', this).each(function(){
                   $('.std-video-inner').each(function(){
                       let elem = this;
                       // if(that.isInViewport(elem)){
                       //     $(elem).play();
                       // }else{#
                       // console.log('pause');
                           elem.pause();
                       // $(elem).pause();
                       // }
                       $(elem).attr('controls',false);

                       if (that.isInViewport(elem)) {
                           elem.play();
                           $(elem).attr('autoplay',true);
                       }

                       // $(elem).attr('autoplay',true);
                       $(window).scroll(function () {
                           if(that.isInViewport(elem)){
                               elem.play();
                               $(elem).attr('autoplay',true);
                           }
                    });
                   });
               // });
           // });
            $('.startVideoonClick').each(function(){
                let that = this;
                // if(that.isInViewport(elem)){
                //     elem.play();
                //     $(elem).attr('autoplay',false);
                // }
                $(this).css({'height':(($('.mb-background-video', this).width() / 16) * 10)});
                // $('.innerVideo', this).css({'display':'block'})
                $('.mb-background-video', this).each(function(){
                   $('.innerVideo', this).each(function(){
                       let elem = this;
                       $('.vidBtn', that).on('click', function(){
                           $(elem).parent().css({'z-index':'10', 'overflow-y': 'visible'});
                           $(elem).attr('loop',true);
                           $(elem).attr('controls',true);
                           elem.play();
                           $(this).hide();
                       });
                       // $(window).scroll(function () {
                       //     let result = that.isInViewport(elem);
                       //     // console.log(elem);
                       //     console.log(result);
                       // });
                   });
               });
           });
        },


		// Check if element is scrolled into view
		isInViewport: function (el) {


            var top = el.offsetTop;
            var left = el.offsetLeft;
            var width = el.offsetWidth;
            var height = el.offsetHeight;

            while(el.offsetParent) {
                el = el.offsetParent;
                top += el.offsetTop;
                left += el.offsetLeft;
            }

            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );



		},


        bindBurger: function() {
            let that = this;
            let mainMenu =  $('#headerMain');
            $('#hamburgerIcon').on('click', function(){
                that.toggleMenu(mainMenu)
            });
        },


        bindContactButton: function() {
            let that = this;
            let cbtn = document.querySelectorAll('.btnContact');
            let mainMenu =  document.querySelector('#headerMain');
            if (typeof(cbtn) != 'undefined' && cbtn != null){
                cbtn.forEach((item)=>{
                    item.addEventListener("click", ()=>{
                        that.toggleMenu(mainMenu)
                    });
                });
            }
        },

        showCrInfo: function(_elem){
            $(_elem).parent().click(function(e) {
                e.preventDefault();
            });
            // let curhref = window.location.href;
            $(_elem).find('p').toggleClass('showInfo');
            setTimeout(function (){
                $(_elem).parent().unbind('click');
            },1000);
        },



        trackMenuPosition: function() {
            let slimit=100;
            let bScroll=Number($("body").scrollTop());
            let hScroll=Number($("html").scrollTop());
            if(hScroll<slimit && bScroll<slimit)
                $('#headerMain').removeClass('scrolled');
            if(hScroll>slimit || bScroll>slimit)
                $('#headerMain').addClass('scrolled');
        },

    enableSelect: function(){
        $('.catSelect').selectpicker({
            liveSearch: false,
            dropupAuto: false,
            iconBase: "fontawesome",
            tickIcon: "fa fa-check"
        });


    },

    toggleMenu: function (menu = $('#headerMain')) {

        let that = this;



            if ($(menu).hasClass('open')) {
                $(menu).removeClass('open');

                let scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
                $('#contentMain').off('click');

            } else {
                // menu.classList.add("open");
                $(menu).addClass('open');

                // When the modal is shown, we want a fixed body
                // document.body.style.top = -1 * window.scrollY+"px";
                // document.body.style.position = 'fixed';
                setTimeout(function () {
                    $('#contentMain').on('click', function(){
                        that.toggleMenu();
                    });
                }, 1000);


            }

        },


        toggleMenue: function (menu) {



            let slimit=100;
            let bScroll=Number($("body").scrollTop());
            let hScroll=Number($("html").scrollTop());
            if(hScroll<slimit && bScroll<slimit)
                $('#headerMain').removeClass('headerStick');
                // $('#headerMain').removeClass('headerStick');
            if(hScroll>slimit || bScroll>slimit)
                $('#headerMain').addClass('headerStick');
                // $('#headerMain').addClass('headerStick');


        },


        checkInView: function (menu) {
            let that = this;
            $('.c-elem').each(function(){
                let elem = this;
                if (that.isInViewport(elem)) {
                    $(elem).addClass('inView');
                }

            });

        },



        setYoutubeBox: function () {
			$('.mubo-b-1').each(function () {

                let parent_h = (($(this).width() / 16) * 9);
                let parent_w = $(this).width();
				if ($('.videoLinkEl', this).length > 0) {
					let srcVal = $('.videoLinkEl', this).data('src-value');
					let ytSrcFind;
					if (srcVal.indexOf('youtu.be') !== -1) {
						ytSrcFind = srcVal.lastIndexOf('/');
					} else {
						ytSrcFind = srcVal.lastIndexOf('=');
					}
					let ytSrcClean = srcVal.slice(ytSrcFind + 1);
					// $('.videoLinkEl', this).find('iframe').attr('src', 'https://www.youtube.com/embed/' + ytSrcClean + '?autoplay=0&mute=1');  //.attr('autoplay','1').get(0).click();
					$('.videoLinkEl', this).find('iframe').attr('src', 'https://www.youtube.com/embed/' + ytSrcClean + '?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0').attr('width', parent_w).attr('height', parent_h);  //.attr('autoplay','1').get(0).click();
					// $('.videoLinkEl', this).find('iframe').attr('src', 'https://www.youtube.com/embed' + ytSrcClean + '?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0');  //.attr('autoplay','1').get(0).click();
				}
			});



        },

        scaleYoutubeBox: function () {
			$('.mubo-b-1').each(function () {

                let parent_h = (($(this).width() / 16) * 9);
                let parent_w = $(this).width();
				if ($('.videoLinkEl', this).length > 0) {
					$('.videoLinkEl', this).find('iframe').attr('width', parent_w).attr('height', parent_h);
				}
			});


        },


        enableAccordion: function(_el){
            let that = this;
            //multibox
            $('.acc-btn').on('click', function() {
                $(this).parent().toggleClass('closed');

            });
            $('.acboInnerContent').each(function () {
                    $('.acbo-element', this).accordion({
                        animate: 300,
                        header: '.acbo-subHead',
                        // header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true,
                    });
            });
            $('.menueItem.head').each(function () {
                let activNum1 = parseInt($('.headItem .headopen.activeSite', this).data('number'));
                let activNum2 = parseInt($('.headItem .subhadopen.activeSite', this).data('number'));
                // $( ".selector" ).on( "accordionbeforeactivate", function( event, ui ) {} );
                    $(this).accordion({
                        event: 'click',
                        // event: 'mouseover',
                        animate: 600,
                        header: '.headopen',
                        collapsible: true,
                        heightStyle: 'content',
                        active: activNum1,
                    });
                    $('.headItem', this).accordion({
                        event: 'click',
                        // event: 'mouseover',
                        animate: 600,
                        header: '.subhadopen',
                        collapsible: true,
                        heightStyle: 'content',
                        active: activNum2,
                    });
                // $('.headItem', this).on( "accordionactivate", function( event, ui ) {
                //     $(this).accordion( "refresh" );
                //     $(ui.newHeader).on('click', function (){
                //         location.href = $(this).attr('href');
                //     });
                // } );

            });


            $('.serienBoxDetails').each(function () {
                    $('.acboSerienDetailsOuter', this).accordion({
                        animate: 300,
                        header: '.serienDetailInnerHeader',
                        // header: 'h3',
                        collapsible: true,
                        heightStyle: 'content',
                        active: true,
                    });
            });


            $('.mb-b-accordionInBox').each(function () {
                    $('.inAccBody, .inAccHead', this).addClass('closed');
                    $('.inAccHead', this).on('click', function(){
                       $(this).toggleClass('closed');
                       $(this).next('.inAccBody').toggleClass('closed');
                    });
            });

            $('.mb-b-accordionInBoxRaw').each(function () {
                    $('.inAccBody, .inAccHead', this).addClass('closed');
                    $('.inAccHead', this).on('click', function(){
                       $(this).toggleClass('closed');
                       $(this).next('.inAccBody').toggleClass('closed');
                    });
            });


            $('.event').each(function () {
                    $('.eventBody, .eventHead', this).addClass('closed');
                    $('.eventHead', this).on('click', function(){
                       $(this).toggleClass('closed');
                       $(this).parent().find('.eventBody').toggleClass('closed');
                    });
            });



		},

        // configureDate: function(){
        //
        //     //multibox
        //     // $('.inboImage .inbo-start-s').each(function () {
        //     $('.inboInnerRightBox .inbo-start-s').each(function () {
        //             $('.inbo-termin-s', this).each(function () {
        //                 let tempDate = $(this).data('termin');
        //                 if(Date.now() > tempDate){
        //                     $(this).addClass('inactive')
        //                 }
        //             });
        //     });
        //
        //
        //
		// },
        //

        closeProbo: function (_el) {
            $(_el).parent().off('click').removeClass('active');
            setTimeout(function(){
                $(_el).parent().on('click', function () {
                    $(this).addClass('active');
                });
            }, 100);
        },

        setProboBoxClick: function(){
            let ma = this;
            $('.plustab').each(function () {
                $(this).on('click', function () {
                    // $(this).addClass('active');
                    $(this).parent().parent().find('.serieProboShow').addClass('active').html($(this).html());
                });
            });


            $('.serienBoxProdukte .probo').each(function () {

                $(this).on('click', function () {
                    let that = this;

                    // $(this).addClass('active');
                    $(this).parent().parent().find('.serieProboShow').addClass('active').html($(this).html());
                    setTimeout(function(){
                        $('.round').addClass('active').on('click', function(){
                            $(that).parent().parent().find('.serieProboShow .proboClose').click();
                            $(this).removeClass('active');
                        });

                        $(that).parent().parent().find('.serieProboShow .plustab').on('click', function () {
                            if($(this).hasClass('plusTab-1')){
                                $(this).parent().find('.plusTabItem-2').addClass('noShow');
                                $(this).parent().find('.plusTabItem-3').addClass('noShow');
                                $(this).parent().find('.plusTabItem-4').addClass('noShow');
                                $(this).parent().find('.plusTabItem-5').addClass('noShow');
                                $(this).parent().find('.plusTabItem-1').removeClass('noShow');
                                $(this).addClass('active');
                                $(this).parent().find('.plusTab-2').removeClass('active');
                                $(this).parent().find('.plusTab-3').removeClass('active');
                                $(this).parent().find('.plusTab-4').removeClass('active');
                                $(this).parent().find('.plusTab-5').removeClass('active');
                            }else if($(this).hasClass('plusTab-2')){
                                $(this).parent().find('.plusTabItem-1').addClass('noShow');
                                $(this).parent().find('.plusTabItem-3').addClass('noShow');
                                $(this).parent().find('.plusTabItem-4').addClass('noShow');
                                $(this).parent().find('.plusTabItem-5').addClass('noShow');
                                $(this).parent().find('.plusTabItem-2').removeClass('noShow');
                                $(this).addClass('active');
                                $(this).parent().find('.plusTab-1').removeClass('active');
                                $(this).parent().find('.plusTab-3').removeClass('active');
                                $(this).parent().find('.plusTab-4').removeClass('active');
                                $(this).parent().find('.plusTab-5').removeClass('active');
                            }else if($(this).hasClass('plusTab-3')){
                                $(this).parent().find('.plusTabItem-1').addClass('noShow');
                                $(this).parent().find('.plusTabItem-2').addClass('noShow');
                                $(this).parent().find('.plusTabItem-4').addClass('noShow');
                                $(this).parent().find('.plusTabItem-5').addClass('noShow');
                                $(this).parent().find('.plusTabItem-3').removeClass('noShow');
                                $(this).addClass('active');
                                $(this).parent().find('.plusTab-1').removeClass('active');
                                $(this).parent().find('.plusTab-2').removeClass('active');
                                $(this).parent().find('.plusTab-4').removeClass('active');
                                $(this).parent().find('.plusTab-5').removeClass('active');
                            }else if($(this).hasClass('plusTab-4')){
                                $(this).parent().find('.plusTabItem-1').addClass('noShow');
                                $(this).parent().find('.plusTabItem-2').addClass('noShow');
                                $(this).parent().find('.plusTabItem-3').addClass('noShow');
                                $(this).parent().find('.plusTabItem-5').addClass('noShow');
                                $(this).parent().find('.plusTabItem-4').removeClass('noShow');
                                $(this).addClass('active');
                                $(this).parent().find('.plusTab-1').removeClass('active');
                                $(this).parent().find('.plusTab-2').removeClass('active');
                                $(this).parent().find('.plusTab-3').removeClass('active');
                                $(this).parent().find('.plusTab-5').removeClass('active');
                            }else if($(this).hasClass('plusTab-5')){
                                $(this).parent().find('.plusTabItem-1').addClass('noShow');
                                $(this).parent().find('.plusTabItem-2').addClass('noShow');
                                $(this).parent().find('.plusTabItem-3').addClass('noShow');
                                $(this).parent().find('.plusTabItem-4').addClass('noShow');
                                $(this).parent().find('.plusTabItem-5').removeClass('noShow');
                                $(this).addClass('active');
                                $(this).parent().find('.plusTab-1').removeClass('active');
                                $(this).parent().find('.plusTab-2').removeClass('active');
                                $(this).parent().find('.plusTab-3').removeClass('active');
                                $(this).parent().find('.plusTab-4').removeClass('active');
                            }
                        });
                    }, 100);

                });
            });

		},

		removeOverlay: function(_el){
			$(_el).hide().parent().find('video').get(0).play();
		},

        slideLoadedSingle: function(){
                let _vid = $('.innerVideo');
                if(_vid.length > 0){
                    var mediaVideo = _vid.get(0);
                    // setTimeout(function(){
                        _vid.parent().css('z-index','-1');
                        _vid.parent().css('display','flex');
                        _vid.parent().parent().find('.mubo-bg').remove();
                        mediaVideo.play();
                    // },1500);


            }


		},
        showMenu: function() {
            //$("#menuContent").show();
            $("body").addClass("menu-open");
        },

        closeMenu: function() {
            //$("#menuContent").hide();
            $("body").removeClass("menu-open");
        },

        //------------------------------------------------------------

        // Check if element is scrolled into view
        isScrolledIntoView: function(elem) {
            let docViewTop = $(window).scrollTop();
            let docViewBottom = docViewTop + $(window).height();

            let elemTop = $(elem).offset().top;
            let elemBottom = elemTop + $(elem).height();

            //return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
            let topInView = ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
            let bottomInView = ((elemBottom <= docViewBottom) && (elemBottom >= docViewTop));
            return topInView || bottomInView;
        },

        //Trigger Animation
        //animateCss($(".personBox"), "shakeX");
        animateCss: function(el, animationName) {

            let animationPrefix = "";//animate__
            //als Promise benachrichtigen, wenn fertig
            return new Promise((resolve, reject) => {
                //gleichzeitig auf Ende horchen und aufräumen
                el.addClass(animationPrefix + 'animated ' + animationPrefix + animationName).one('animationend', function () {
                    el.removeClass(animationPrefix + 'animated ' + animationName);
                    //fertig
                    resolve();
                });
            });
        },


        //scroll-basierte Animationen triggern
        runScrollAnimation: function() {
            // let that = this;
            // $('.scroll-animations .animated').each(function () {
            //     if (that.isScrolledIntoView(this) === true) {
            //
            //         let thisEl = $(this);
            //
            //         if (thisEl.hasClass("animated-left")) {
            //             thisEl.addClass('fadeInLeft ');
            //         }
            //         if (thisEl.hasClass("animated-up")) {
            //             thisEl.addClass('fadeInUp ');
            //         }
            //         if (thisEl.hasClass("animated-right")) {
            //             thisEl.addClass('fadeInRight');
            //         }
            //         if (thisEl.hasClass("animated-fadeIn")) {
            //             thisEl.addClass('fadeIn');
            //         }
            //         if (thisEl.hasClass("animated-zoom")) {
            //             thisEl.addClass('zoomIn');
            //             setTimeout(function () {
            //                 thisEl.removeClass('animated-zoom zoomIn');
            //             }, 1000);
            //         }
            //     }
            //     else{
            //
            //         //Reset oben /NOT: und unten
            //         let scrollTop = $(window).scrollTop();
            //         let scrollHeight = $(document).height();
            //         let scrollPosition = $(window).height() + $(window).scrollTop();
            //         if ((scrollTop === 0) /*|| ((scrollHeight - scrollPosition) / scrollHeight === 0)*/) {
            //             $(this).removeClass('fadeInLeft fadeInUp fadeInRight fadeIn');
            //         }
            //     }
            // });
        },


        checkDownloadSum: function(){
            if($('.downloadBox').length > 0){
                $('.orderBox').on('click', function(){
                    if($('.orderBox:checked').length > 0){
                        let katalogValue = '';
                        $('.orderBox:checked').each(function() {
                            katalogValue += $(this).val() + '++';
                        });
                        setTimeout(function (){
                            $('#kataloge-katalog').val(katalogValue);
                        },100);
                        if(!$('.katalogForm').hasClass('active')){
                            // $('.showFormBtn').addClass('active').on('click', function() {
                                let katInput = '<input type="hidden" class="hiddenInput" name="kataloge" id="kataloge-katalog" value="">'
                                $('.katalogForm').addClass('active');
                                katalogValue = '';
                                $('.orderBox:checked').each(function() {
                                    katalogValue += $(this).val() + '++';
                                });
                                if($('#kataloge-katalog').length < 1){
                                    $('.katalogForm form').prepend(katInput);
                                    $('#kataloge-katalog').val(katalogValue);
                                }
                                // $(this).removeClass('active');
                            // });
                        }

                    }else{
                        // $('.showFormBtn').removeClass('active');
                        $('.katalogForm').removeClass('active');
                    }
                    if($('.orderBox:checked').length > 20){
                        $('.orderBox').prop( "disabled", true );
                        $('.orderBox:checked').prop( "disabled", false );
                    }else{
                        $('.orderBox').prop( "disabled", false );
                    }
                });
            }
        }

    };

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicViewService);
}());